import React from 'react';

const Loading = () => {
    return (
        <>
            loading...
        </>
    );
};

export default Loading;